<script>
export default {
  page: {
    title: 'Agent List Agent Admin',
    meta: [
      { name: 'description', content: 'The Agent List Agent Admin page.' },
    ],
  },
}
</script>

<template>
  <div>
    Agent List Agent Admin
  </div>
</template>
